import axios from 'axios';
import { getHeaders } from '../actions/helper.action';
import { SOCKET_ROOT } from '../config/appConfig';

export const getSurveySampleByIdApi = async (sampleId, jwt) => {
  const res = await axios.get(`${SOCKET_ROOT}/sample/${sampleId}`, {
    method: 'GET',
    mode: 'cors',
    headers: {
      Authorization: `Bearer ${jwt}`,
      'Content-Type': 'application/json',
    },
  });

  if (res.status === 200) {
    return res.data;
  }
  return null;
};

export const updateSurveySampleByIdApi = async (sampleId, data, jwt) => {
  await axios.patch(`${SOCKET_ROOT}/sample/${sampleId}`, data, getHeaders('application/json', jwt));
};

export const getSurveySampleDimensionsByIdApi = async (sampleId, jwt) => {
  const res = await axios.get(`${SOCKET_ROOT}/sample/${sampleId}/dimensions`, {
    method: 'GET',
    mode: 'cors',
    headers: {
      Authorization: `Bearer ${jwt}`,
      'Content-Type': 'application/json',
    },
  });

  if (res.status === 200) {
    return res.data;
  }
  return null;
};

export const updateSurveyDimensionByIdApi = async (sampleId, data, jwt) => {
  await axios.patch(
    `${SOCKET_ROOT}/dimension/${sampleId}`,
    data,
    getHeaders('application/json', jwt)
  );
};

export const moveSampleOnSectionApi = async (sampleId, place, jwt) => {
  await axios.patch(
    `${SOCKET_ROOT}/sample/${sampleId}/move`,
    { place },
    getHeaders('application/json', jwt)
  );
};
